import axios from 'axios'
// import store from '@/store'
import {getToken} from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API_JQ, // api的base_url
  timeout: 1000 * 30 // 请求超时时间
})


// request拦截器
service.interceptors.request.use(config => {
  // Do something before request is sent
  // if (store.getters.token) {
  config.headers['token'] = config.headers['token']||getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
  // }
  // console.log('i am request 拦截器') // for debug
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})


// 响应拦截（配置请求回来的信息）
service.interceptors.response.use(function (response) {
  // 处理响应数据
  return response.data;
}, function (error) {
  // 处理响应失败
  return Promise.reject(error);
});

export default service



// WEBPACK FOOTER //
// ./src/utils/jqReqyest.js